<template>
  <!-- prettier-ignore -->
  <div class="container_menu">
    <div class="menu">
      <el-switch @change="changeCn" v-model="cnFlag" active-text="中文" inactive-text="English" style="margin-bottom:10px;"></el-switch>
      <ul class="menu-list">
        <li v-for="(item, index) in leftDataGroup" :key="index" @click="getGrop(item, index)">
          <p :class="{ checked: index === selected }" class="line2">
            <span class="unchecked" :title="cnFlag?item.zhName:item.topicName">{{ cnFlag?item.zhName:item.topicName }}</span>
          </p>
          <p class="line2" :title="cnFlag?item.zhDescription:item.description">描述：{{ cnFlag?item.zhDescription:item.description }}</p>
          <p class="onlyFlag" v-if="!scope">
            匹配分数：<span class="menu-result">{{ item.count }}</span>
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { isScrollWillDown80 } from "../assets/js/scroll";
export default {
  name: "LeftMenu",
  props: {
    leftData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    scope: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    leftData: {
      immediate: true,
      handler(val) {
        this.selected = 0;
        this.leftDataGroup = val;
        this.leftDataGroupCopy = this.leftDataGroup;
        this.readNum++;
      },
    },
  },
  data() {
    return {
      readNum: 0,
      leftDataGroup: [],
      leftDataGroupCopy: [], //左侧距和副本  当左侧距和为空时有用
      filterArray: [], //根据选中的 获取到选中的过滤对象
      selected: 0,
      scrollshow: false,
      menushow: false,
      cnFlag: false,
    };
  },

  mounted() {},
  methods: {
    changeCn(val) {
      this.cnFlag = val;
    },
    getGrop(item, checkidx) {
      this.selected = checkidx;
      let obj = {
        topicSid: item.sid,
        topictotal: item.worksCount,
        description: item.description,
      };
      //选中的传给父组件
      this.$emit("childByValue", obj);
    },
  },
};
</script>

<style lang="scss" scoped>
.container_menu {
  width: 250px;
  max-width: 250px;
  min-width: 0;
  position: relative;
  margin-right: 20px;
  min-height: 100px;
  float: left;
  min-height: 200px;
}

@media (max-width: 1024px) {
  .container_menu {
    width: 100%;
    max-width: none;
    margin-right: 0;
    margin-bottom: 10px;
    float: none;
  }

  .menu-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px 20px;

    li {
      min-width: 0;
      margin-bottom: 0;
    }
  }
}

@media (max-width: 600px) {
  .menu-list {
    grid-template-columns: 1fr;
  }
}

.menu {
  background: #fff;
  padding: 15px 20px;
  margin-bottom: 10px;
  position: relative;
}
.menu-list {
  p {
    line-height: 22px;
    margin-bottom: 5px;
    color: #666;
    font-size: 14px;
    &:nth-of-type(1) {
      color: #333;
      font-size: 16px;
      font-weight: 400;
    }
    &:last-of-type {
      margin: 0;
    }
  }
  .unchecked {
    color: #333;
    font-size: inherit;
    line-height: 20px;
    cursor: pointer;
  }
  .unchecked:hover {
    background-image: linear-gradient(to right, #006eb3, #2d8cf0);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .checked span {
    cursor: pointer;
    background-image: linear-gradient(to right, #006eb3, #2d8cf0);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  li {
    align-items: center;
    margin-bottom: 20px;
    cursor: pointer;
    &:last-of-type {
      margin: 0;
    }

    .menu-result {
      margin-left: auto;
      color: #ff0000;
    }
  }
}
</style>
